import { ScrollView } from "../ScrollView.js";
import { IScrollViewScale } from "./IScrollViewScale.js";

export class ScrollViewScaleCoverWidth implements IScrollViewScale {
    public getScale(view: ScrollView): number {
        return view.width / view.contentWidth;
    }
}